import type { PortfolioItemGroupName } from '@savvy/constants/generated/gql-types';
import {
  PORTFOLIO_ITEM_GROUP_BANK_ACCOUNTS,
  PORTFOLIO_ITEM_GROUP_COMPANY_EQUITY,
  PORTFOLIO_ITEM_GROUP_OTHER_ASSETS,
  PORTFOLIO_ITEM_GROUP_OTHER_INVESTMENTS,
  PORTFOLIO_ITEM_GROUP_OTHER_LIABILITIES,
  PORTFOLIO_ITEM_GROUP_REAL_ESTATE,
  PORTFOLIO_ITEM_GROUP_SAVVY_ACCOUNTS,
} from '@savvy/constants/portfolio-item-groups';

export const PORTFOLIO_ITEM_GROUP_DISPLAY_NAMES: Record<PortfolioItemGroupName, string> = {
  [PORTFOLIO_ITEM_GROUP_BANK_ACCOUNTS]: 'Cash',
  [PORTFOLIO_ITEM_GROUP_REAL_ESTATE]: 'Real estate',
  [PORTFOLIO_ITEM_GROUP_SAVVY_ACCOUNTS]: 'Savvy investments',
  [PORTFOLIO_ITEM_GROUP_OTHER_ASSETS]: 'Other assets',
  [PORTFOLIO_ITEM_GROUP_OTHER_INVESTMENTS]: 'Other investments',
  [PORTFOLIO_ITEM_GROUP_COMPANY_EQUITY]: 'Company equity',
  [PORTFOLIO_ITEM_GROUP_OTHER_LIABILITIES]: 'Other liabilities',
};
